module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "partnum"
  }, [_c('i', [_vm._v("Part I")])]), _vm._v(" "), _c('p', {
    staticClass: "parttit"
  }, [_vm._v("ANSWERING THE CALL: THOSE WHO VOLUNTEERED")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("I appeal to all loyal citizens to favor, facilitate, and aid this effort to maintain the honor, the integrity, and the existence of our National Union, and the perpetuity of popular government")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("—President Abraham Lincoln, A Proclamation, April 15, 1861")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50e5e2a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/part01.vue
// module id = 78
// module chunks = 0